import { DefaultSearch } from './DefaultSearchPage';

import { EnterpriseSearch } from './EnterpriseSearchPage';
import { ConfigHelper } from '@devxdiscover/devhub-common';

const SearchPage = () => {
  const searchBackend = ConfigHelper?.instance?.searchBackend;
  const isEnterpriseSearch = searchBackend === 'enterpriseSearch';
  return <>{isEnterpriseSearch ? <>{EnterpriseSearch}</> : DefaultSearch}</>;
};

/**
 * The search page component for rendering the search page.
 */
export const DevhubSearchPage = <SearchPage />;
